module.exports = __webpack_public_path__ + "img/IMG_8476.9e871fd1.jpg";